import {useUDData} from '@udemy/ud-data';

import {languageToDefaultCountry} from '../utils/language-to-default-country';

export const useVerifyIsUsMarketplace = (locale: string) => {
    const {Config} = useUDData();
    const fallbackCountry = languageToDefaultCountry(locale);
    const isFallbackCountryUS = !Config.marketplace_country && fallbackCountry === 'us';
    const isUSMarketplace = !isFallbackCountryUS && Config.marketplace_country?.id === 'US';

    return {
        isUSMarketplace,
        isFallbackCountryUS,
    };
};
